import cx from 'classnames';
import BootstrapFormCheck from 'react-bootstrap/FormCheck';
import css from './Checkbox.module.scss';

const Checkbox = ({ className = '', ...props }) => (
  <BootstrapFormCheck
    className={cx(className, css.checkbox)}
    {...props}
    type="checkbox"
  />
);

Checkbox.propTypes = BootstrapFormCheck.propTypes;

export { Checkbox };
